// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"706":"e32f85f1f5801808","4737":"7527de0d3397a339","5453":"d51f87ab67abba38","6358":"d01e337870b673db","6726":"6d0536fa12160466","7660":"1de7480ed8082a02"}[chunkId] + ".css";
};